export { addTelemetryDebug, addTelemetryError, startFakeTelemetry, resetTelemetry, startTelemetry, isTelemetryReplicationAllowed, addTelemetryConfiguration, addTelemetryUsage, drainPreStartTelemetry, } from './telemetry';
export * from './rawTelemetryEvent.types';
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./~/@datadog/browser-rum-core/~/@datadog/browser-core/esm/domain/telemetry/index.js